import Contact from '../../../../../common/personnes/components/mini-form/contact/mini.form.contact.model';
import * as angular from 'angular';

export default class ChantierFormEnteteController {
	contacts = [];
	contactsSelected = [];
	newContact = new Contact();
	firstLaunch1 = true;
	firstLaunch2 = true;

	/* @ngInject */
	constructor(
		$scope,
		$state,
		$stateParams,
		$translate,
		ChantiersCommunicationService,
		ChantiersService,
		ChantiersTypesService,
		notification,
		SitesService,
		MassiaApplicationService,
		ApiGeoService,
		LieuxService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$translate = $translate;
		this.ChantiersCommunicationService = ChantiersCommunicationService;
		this.ChantiersService = ChantiersService;
		this.ChantiersTypesService = ChantiersTypesService;
		this.notification = notification;
		this.SitesService = SitesService;
		this.MassiaApplicationService = MassiaApplicationService;
		this.ApiGeoService = ApiGeoService;
		this.LieuxService = LieuxService;
		this.textMaskConfigTel = {
			showMask: false,
			mask: [[0], /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
		};
	}

	async $onInit() {
		this.isChantier = this.$stateParams.genre === 'chantiers';
		this.unregister = [];
		this.loading = false;
		this.codeLoading = false;
		this.lieux = [];
		this.chantier.entete.idLieu = this.$stateParams?.idLieu || this.chantier.entete.idLieu;
		this.getLieux();

		if (this.$stateParams && this.$stateParams?.id) {
			this.isEditMode = true;
			this.setChantierAsTypeAhead();
		} else {
			this.isEditMode = false;
		}

		this.hasTypes = false;
		this.chantier = this.chantier || {};
		//retour de la page lieu
		if (this.$stateParams.newObjectEntete && this.$stateParams.fromLieu) {
			this.chantier.entete = this.$stateParams.newObjectEntete;
			this.chantier.entete.idLieu = this.$stateParams.idLieu;
			this.chantier.entete.idSociete = this.$stateParams.newObjectEntete.objetSociete?.id || 0;
			this.chantier.entete.nomSociete = this.$stateParams.newObjectEntete.objetSociete?.libelle || null;
			this.chantier.entete.codeSociete = this.$stateParams.newObjectEntete.objetSociete?.code || null;
			this.chantier.entete.idSite = this.$stateParams.newObjectEntete.objetSiteClient?.id || null;
			this.chantier.entete.nomSite = this.$stateParams.newObjectEntete.objetSiteClient?.libelle || null;
			this.chantier.entete.codeSite = this.$stateParams.newObjectEntete.objetSiteClient?.code || null;
		}

		this.entete = this.chantier.entete;
		this.adresse = null;
		try {
			this.entete.estCodeAuto = await this.ChantiersService.estCodeAuto();
			if (this.entete.estCodeAuto) {
				this.entete.afficheCode = await this.ChantiersService.afficheCode('chantiers');
			} else {
				this.entete.afficheCode = true;
			}
		} catch (ex) {
			this.notification.error(ex.data);
			this.annuler();
		}

		this.types = this.types || [];
		// on sauvegarde la fonction de désabonnement pour l'invoquer au destroy
		// il est important de noter la façon de s'abonner :
		// on utilise les arrow functions, () => {},
		// elles permettent de sauvegarder l'état du 'this'
		// et d'éviter la perte du contexte lors de l'appel de la fonction depuis un autre controller
		this.unregisterReinit = this.ChantiersCommunicationService.registerReinit(() => this.initForm());

		this.isClientDisabled = false;
		if (this.$stateParams.clientId) {
			this.isClientDisabled = true;
		} else {
			if (this.entete.isClientDisabled) {
				this.isClientDisabled = true;
			}
		}

		await this.getNiveauVisibilite();
		await this.clientChange();

		this.contacts.forEach(function (contact) {
			if (contact?.id == this.chantier.entete.idContact) {
				contact.selected = true;
			}
		}, this);

		if (this.chantier.entete.idContact) {
			this.contactsSelected.push({ id: this.chantier.entete.idContact, libelle: this.chantier.entete.nomContact });
		}

		if (this.chantier.entete.idLieu) {
			this.setChantierAsTypeAhead();

			// this.lieu = this.chantier.entete.idLieu;
		}

		//Met a jour lors du changement de siteclient
		this.unregister.push(
			this.$scope.$watch(
				() => this.entete.objetSiteClient,
				async () => {
					if (!this.firstLaunch1 === false) {
						this.firstLaunch1 = false;
					} else {
						this.entete.isClientDuBatiment = false;
						const siteClient = this.chantier.entete.objetSiteClient;
						if (siteClient && siteClient.id != null && this.entete.isHeritageFromClient) {
							this.entete.isDuBatiment = siteClient.isDuBatiment;
							this.entete.isClientDuBatiment = siteClient.isDuBatiment;
						}
					}
				}
			)
		);

		this.unregister.push(
			this.$scope.$watch(
				() => this.entete.isHeritageFromClient,
				async () => {
					if (!this.firstLaunch2 === false) {
						this.firstLaunch2 = false;
					} else {
						this.changeEnteteChantierBatiment();
					}
				}
			)
		);

		//Gestion des switch contaminations
		this.unregister.push(
			this.$scope.$watch(
				() => this.entete.isPotentielContamine,
				async (newValue) => {
					if (newValue && this.entete.isContamine) {
						this.entete.isContamine = false;
					}
				}
			)
		);

		this.unregister.push(
			this.$scope.$watch(
				() => this.entete.isContamine,
				async (newValue) => {
					if (newValue && this.entete.isPotentielContamine) {
						this.entete.isPotentielContamine = false;
					}
				}
			)
		);

		if (this.chantier.entete.objetSociete?.id === 0) {
			this.entete.nomSociete = null;
			this.entete.objetSociete = null;
		}

		this.isSocieteOpen = false;
		this.isSocieteClosed = false;
		this.currentCompteOuverts = [];
		if (this.entete.idSite) {
			let res = await this.getCompteOuverts(this.entete.idSite);
			res.forEach((element) => {
				this.currentCompteOuverts.push(element);
			});
			this.updateSocieteClosedWarning();
		}

		if (!this.isEditMode) {
			this.entete.isHeritageFromClient = true;
		}
	}

	async getNiveauVisibilite() {
		if (this.entete.typeId) {
			this.entete.niveauVisibilite = await this.ChantiersTypesService.GetNiveauVisibilite(this.entete.typeId);
		}
	}

	// SL si un changement est fait dans le parent,
	// on met a jour les donnees dans l enfant
	$onChanges(objChanges) {
		if (objChanges.chantier) {
			this.getPayss();
			this.getTypes();
			//this.getLieux();
		}
	}

	// SL si angular voit que les donnees originales sont differentes des donnees dupliquees
	// le parent recupere les donnees de l enfant
	$doCheck() {
		if (!angular.equals(this.entete, this.chantier.entete)) {
			this.onUpdate({
				entete: angular.copy(this.entete)
			});
		}
	}

	$onDestroy() {
		this.unregisterReinit();

		for (let i = 0; i < this.unregister?.length; i++) {
			this.unregister[i]();
		}
	}
	// debug() {
	// 	console.log('👻: ChantierFormEnteteController -> debug -> ', this);
	// }

	async getTypes() {
		try {
			this.types = await this.ChantiersTypesService.getAll();
			this.hasTypes = this.types?.length > 0;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getPayss() {
		try {
			this.payss = await this.ChantiersService.getAllPayss();
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getSites() {
		try {
			// SL appel du get permettant de remplir les combobox
			this.sites = await this.SitesService.getSitesHeaders();
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getLieux() {
		this.lieux = (await this.LieuxService.getLieux()).items;
		if (this.chantier.entete.idLieu) {
			const selectedLieu = this.lieux.find((lieu) => lieu.id === +this.chantier.entete.idLieu);
			if (selectedLieu) {
				selectedLieu.selected = true;
				this.selectedLieu = [selectedLieu];
				this.saveSelectedLieux();
			}
		}
	}

	saveSelectedLieux() {
		if (this.selectedLieu.length === 0) {
			this.chantier.entete.idLieu = null;
			this.chantier.entete.nomLieu = null;
			this.chantier.entete.codeLieu = null;
		} else {
			this.chantier.entete.idLieu = this.selectedLieu[0].id;
			this.chantier.entete.nomLieu = this.selectedLieu[0].libelle;
			this.chantier.entete.codeLieu = this.selectedLieu[0].code;
		}
	}

	async getNomSiteClients(valeur) {
		try {
			const res = await this.ChantiersService.getNomSiteClients(valeur, this.isChantier);
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getSociete(valeur) {
		try {
			const res = await this.ChantiersService.getSocietes(valeur);
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getCompteOuverts(valeur) {
		try {
			const res = await this.ChantiersService.getCompteOuverts(valeur, 2);
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async checkCodeUnicity(code) {
		if (!code) {
			this.chantier.entete.codeExists = null;
			return;
		}
		this.startCodeLoading();
		try {
			if (code.match(/^[a-zA-Z0-9_|]*$/)) {
				this.entete.codeExists = await this.ChantiersService.codeExists(code);
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopCodeLoading();
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	startCodeLoading() {
		this.codeLoading = true;
	}

	stopCodeLoading() {
		this.codeLoading = false;
	}

	setTypeAheadAs(val) {
		if (!this.chantier) {
			this.chantier = {};
		}
		switch (val) {
			case 'siteClient':
				this.chantier.entete.idSite = this.siteClient.id;
				this.chantier.entete.nomSite = this.siteClient.libelle;
				this.chantier.entete.codeSite = this.siteClient.code;
				this.getChantiers();
				break;
			case 'lieu':
				this.entete.idLieu = this.lieu.id;
				this.entete.nomLieu = this.lieu.libelle;
				this.entete.codeLieu = this.lieu.code;
				break;
		}
	}

	setChantierAsTypeAhead() {
		if (this.chantier.entete.idSite) {
			this.chantier.entete.objetSiteClient = {
				id: this.chantier.entete.idSite,
				libelle: this.chantier.entete.nomSite,
				code: this.chantier.entete.codeSite
			};
		}
		if (this.chantier.entete.idSociete && this.chantier.entete.idSociete != 0) {
			this.chantier.entete.objetSociete = {
				id: this.chantier.entete.idSociete,
				libelle: this.chantier.entete.nomSociete,
				code: this.chantier.entete.codeSociete
			};
		} else {
			this.chantier.entete.nomSociete = null;
			this.chantier.entete.objetSociete = null;
		}
		this.lieu = {
			id: this.chantier.entete.idLieu,
			code: this.chantier.entete.codeLieu,
			libelle: this.chantier.entete.nomLieu,
			codeEtLib: this.chantier.entete.idLieu ? this.chantier.entete.nomLieu + ' [' + this.chantier.entete.codeLieu + ']' : ''
		};
	}

	async changeEnteteChantierBatiment() {
		if (this.entete.isHeritageFromClient) {
			this.entete.isDuBatiment = this.entete.isClientDuBatiment;
		}
	}

	videLieu() {
		// if (!this.isClientDisabled) {
		this.lieu = {
			id: undefined,
			code: undefined,
			libelle: undefined,
			codeEtLib: ''
		};
		this.entete.idLieu = undefined;
		this.entete.nomLieu = undefined;
		this.entete.codeLieu = undefined;
		// }
	}

	async clientChange() {
		this.contactsSelected = [];
		if (this.chantier.entete.objetSiteClient && this.chantier.entete.objetSiteClient.id != null) {
			this.contacts = await this.ChantiersService.getContactsBySite(this.chantier.entete.objetSiteClient.id);
		}
	}

	async societeChange() {
		this.updateSocieteClosedWarning();
	}

	updateSocieteClosedWarning() {
		if (!this.entete.objetSociete || !this.entete.objetSociete.code) {
			this.isSocieteClosed = false;
			this.isSocieteOpen = false;
		} else {
			this.isSocieteClosed = true;
			this.isSocieteOpen = false;
			this.currentCompteOuverts.forEach((element) => {
				if (this.entete.objetSociete.code == element.codeSociete) {
					this.isSocieteClosed = false;
					this.isSocieteOpen = true;
				}
			});
		}
	}

	contactChange() {
		this.entete.idContact = this.contactsSelected.length === 1 ? this.contactsSelected[0].id : null;
	}

	selectNewContact() {
		this.contacts.forEach((contact) => (contact.selected = false));
		if (this.newContact.id) {
			const newContact = {
				id: this.newContact.id,
				libelle: `${this.newContact.prenom} ${this.newContact.nom}`,
				selected: true
			};
			this.contacts = [...this.contacts, newContact];
			this.contactsSelected = [newContact];
			this.entete.idContact = this.newContact.id;
		}
	}

	goTo(direction) {
		if (direction === 'lieux.new') {
			this.$state.go('lieux.new', { fromChantier: true, newObjectEntete: angular.copy(this.chantier.entete) });
		}
		if (direction === 'lieux.edit') {
			this.$state.go('lieux.edit', {
				id: this.chantier.entete.idLieu,
				fromChantier: true,
				newObjectEntete: angular.copy(this.chantier.entete)
			});
		}
	}
}
